import React, { Component } from 'react';
import { connect } from 'react-redux';
import { View, FlatList } from 'react-native'

import Header from '../../../components/Header';
import { RateAvatar } from '../../../components';
import { loader, getStranth, getProgressLevels } from '../../../action';
import { global } from '../../../const';
import styles from '../../../styles';
import localize from '../../../localize';


class Progress extends Component {

    constructor(props) {
        super(props);
        let id, type;
        if (!global.isNative) {
            const query = new URLSearchParams(props.location.search);
            id = query.get('id') || props.userInfo.family_id;
            type = query.get('type') || 1;
        }

        this.state = {
            progress: [],
            type,         // 0.User   1.Family   2.Team
            id,
        }
    }



    componentWillMount() {
        this.getProgress()
    }

    getProgress = async () => {
        const { type, id } = this.state;
        try {
            this.props.loader(true);
            let { progressLevel, familyStrenght, userStrength, teamStrenght } = this.props.setting
            if (progressLevel.length <= 0) progressLevel = await this.props.getProgressLevels()

            let strengthLevel = []
            if (type === 1) {
                if (id === familyStrenght.family_id) strengthLevel = familyStrenght
                if (strengthLevel.length < 1) {
                    strengthLevel = await this.props.getStranth('', id)
                    strengthLevel = strengthLevel[0]
                }
            } else if (type === 2) {
                if (id === teamStrenght.team_id) strengthLevel = teamStrenght
                if (strengthLevel.length < 1) {
                    strengthLevel = await this.props.getStranth('', '', id)
                    strengthLevel = strengthLevel[0]
                }
            } else {
                if (id === userStrength.id) strengthLevel = userStrength
                if (strengthLevel.length < 1) {
                    strengthLevel = await this.props.getStranth(id)
                    strengthLevel = strengthLevel[0]
                }
            }

            let progressWithstrenth = [];
            let strength = strengthLevel ? Number(strengthLevel.strength) : 0;
            progressLevel[type === 1 ? 'family' : type === 2 ? 'team' : 'user'].map((item) => {
                if (strength < 100 && strength > 0) {
                    item['strength'] = strength;
                    strength = strength - strength;
                } else if (strength >= 100) {
                    item['strength'] = 100;
                    strength = strength - 100;
                } else {
                    item['strength'] = 0;
                }
                return progressWithstrenth.push(item);
            })
            this.setState({ progress: progressWithstrenth })
            this.props.loader(false);
        } catch (error) {
            this.props.loader(false);
            console.log(error)
        }
    }


    renderRow = ({ item }) => {
        return (
            <View style={{ paddingBottom: 20 }}>
                <RateAvatar rate={item.strength} title={item.name} />
            </View>
        )
    }

    render() {
        const { progress, type } = this.state;
        return (
            <View style={styles.container}>

                {
                    !global.isNative && (
                        <Header
                            title={`${type === 1 ? localize.Family : type === 2 ? localize.Team : localize.User} ` + localize.Level}
                            goBack={() => this.props.history.goBack()}
                        />)
                }

                <View style={{ marginHorizontal: 20, paddingTop: 20, height: this.props.setting.height }}>
                    <FlatList
                        data={progress}
                        numColumns={3}
                        keyExtractor={(item, index) => index}
                        renderItem={this.renderRow}
                        columnWrapperStyle={{ justifyContent: 'space-between' }}
                    />
                </View>
            </View>
        )
    }
}

const mapStateToProps = ({ setting, auth }) => {
    return {
        setting: setting,
        userInfo: auth.userInfo,
    }
}
const mapDispatch = (dispatch) => {
    return {
        loader: request => dispatch(loader(request)),
        getStranth: (user, family, team) => dispatch(getStranth(user, family, team)),
        getProgressLevels: () => dispatch(getProgressLevels()),
    }
}
export default connect(mapStateToProps, mapDispatch)(Progress);